module.exports = __webpack_public_path__ + "static/about-three-small-a71233ee5f9e8cbf6b5c5b036692319d.jpg";